import { css } from "../../../../styled-system/css";

export const styles = {
  iframeWrapper: () =>
    css({
      paddingBottom: "56.25%",
      position: "relative",
      display: "block",
      width: "100%",
      "& iframe": {
        height: "100%",
        width: "100%",
        position: "absolute",
        top: "0",
        left: "0",
      },
    }),
};
